import PersonalAccessTokensTable from "features/personalAccessTokensTable/personalAccessTokensTable";
import PageLayout from "layouts/developerPortal/pageLayout";
import Content from "layouts/developerPortal/content";

function PersonalAccessTokensPage() {
  return (
    <PageLayout>
      <Content>
        <PersonalAccessTokensTable />
      </Content>
    </PageLayout>
  );
}

export default PersonalAccessTokensPage;
